import { FlightRequest,  FlightRequestParams,  FlightResponse,  RequestDetails } from "pages/Request/Types";
import axiosClient from "./axios-client";
import { AxiosResponse } from "axios";


const GET_FLIGHT_REQUESTS_URL = "/Request/GetFlightRequests";

export const getFlightRequests = async (params: FlightRequestParams): Promise<FlightResponse> => {
  try {
    const response: AxiosResponse<FlightResponse> = await axiosClient.get(GET_FLIGHT_REQUESTS_URL, {
      params,
    });
    
    return response as unknown as FlightResponse;
  } catch (error) {
    console.error("Error fetching flight requests:", error);
    throw error;
  }
};



export const submitFlightResponse = async (data: {
  requestDetailId: number;
  firstClass: number;
  businessClass: number;
  economyPlusClass: number;
  economyClass: number;
  nonRevListed: number;
  nonFirst: number;
  nonBusiness: number;
  nonEconomyPlus: number;
  nonEconomy: number;
  moreFirstClass: boolean;
  moreBusinessClass: boolean;
  moreEcoClass: boolean;
  moreEcoPlus: boolean;
  comments: string;
}) => {
  try {
    const response = await axiosClient.post("/Request/SubmitResponse", data);
    return response;
  } catch (error) {
    console.error("Error submitting flight response:", error);
    throw error;
  }
};


  export const getAnsweredRequest = async (requestDetailId: number): Promise<any> => {
    try {
      const response:  AxiosResponse<any> = await axiosClient.get('/Request/AnsweredRequest', {
        params: { requestDetailId },
      });
  
      return response; 
    } catch (error) {
      console.error('Error fetching answered request:', error);
      throw error;
    }
  };

  export const checkRequestStatus = async (requestId: number): Promise<any> => {
    try {
      const response: AxiosResponse<any> = await axiosClient.get('/Request/CheckRequestStatus', {
        params: { requestId },
      });
  
      return response; 
    } catch (error) {
      console.error('Error fetching request status:', error);
      throw error;
    }
  };

  export const lockUnlockResponse = async (requestDetailId: number, isCancelled: boolean): Promise<any> => {
    try {
      const response: AxiosResponse<any> = await axiosClient.get('/Request/LockUnlockResponse', {
        params: { 
          requestDetailId,
          isCancelled 
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error processing lock/unlock request:', error);
      throw error;
    }
};

export const getOpenRequestCount = async (): Promise<any> => {
  try {
    return await axiosClient.get('/Request/OpenRequestCount');
  } catch (error) {
    console.error('Error fetching open request count:', error);
    throw error;
  }
};

 export const displayNameInfo = async (userId: number): Promise<any> => {
    try {
      const response:  AxiosResponse<any> = await axiosClient.get('/Settings/DisplayNameInfo', {
        params: { userId },
      });
  
      return response; 
    } catch (error) {
      console.error('Error fetching requested user name:', error);
      throw error;
    }
  };